import styled from '@emotion/styled'
import tw from 'twin.macro'

export const ClosedWrapper = styled('div')`
  ${tw`text-center`}
  * {
    ${tw`mx-auto`}
  }
`
